import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import * as NavigationAction from '@flow/store/navigation/actions';
import { RouteComponentProps, withRouter } from 'react-router';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { LocationListener } from "history";
import { OverlayNavigationList, AuxNavigation, SocialMediaNavigation } from "@flow/components/navigation";
import FlowStripe from '@flow/components/ticker/FlowStripe';
import { OVERLAY_TRANSITION_DURATION } from "@flow/utils/constants";
import { getMobileOperatingSystem } from "@flow/utils/deviceDetection";

const Wrapper = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1004;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  
  &:before {
    content: '';
    background-color: ${props => props.theme.highlightColor};
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
`;

const CloseButton = styled.a`
  position: fixed;
  top: 2em;
  right: 3.6em;
  width: 3.2em;
  height: 3.6em;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 90;
  color: white;
  
  &:before {
    content: '';
    width: .5em;
    height: 3.6em;
    position: absolute;
    top: 0;
    left: 50%;
    transform: rotate(45deg);
    background: black;
  }
  
  &:after {
    content: '';
    width: .5em;
    height: 3.6em;
    position: absolute;
    top: 0;
    left: 50%;
    transform: rotate(-45deg);
    background: black;
  }
`;

const StripeWrapper = styled.div`
  border-top: 0.2em solid white;
  border-bottom: 0.2em solid white;
  overflow: hidden;
  background-color: ${props => props.theme.highlightColor};
`;

const AuxNavigationWrapper = styled.div`
  margin-bottom: 3em;
`;

const OverlayBottomContent = styled.div`
  text-align: center;
  padding: 12em 1em;
  //background-color: ${props => props.theme.highlightColor};
`;

const OverlayWrapper = styled.div`
  position: relative;
  height: 100%;
  z-index: 1;
  display: flex;
  flex-direction: column;
  
  @media only screen and (max-width: ${props => props.theme.narrowOverlayNavPoint}px) {
    display: block;
    overflow-y: scroll;
    
    ${StripeWrapper} {
      display: none;
    }
    
    ${OverlayBottomContent} {
      padding: 5em 1em;
    }
  }
  
  @media only screen and (max-width: 600px) {
    ${AuxNavigationWrapper} {
      //display: none;
    }
  }
  
  @media only screen and (max-height: 1000px) {
    ${OverlayBottomContent} {
      font-size: 80%;
      padding: 5em 1em 2em;
    }
  }
`;

interface Props extends RouteComponentProps<{}> {
  appLanguage: IAppLanguage;
  _onHideClick: () => any;
  visible: boolean;
}

class OverlayNavigationContainer extends React.Component<Props, any> {

  listener: LocationListener;
  document: HTMLDocument;

  noScroll: any;

  constructor(props: Props) {
    super(props);
    this.noScroll = require('no-scroll');
  }


  componentDidMount() {
    const {
      _onHideClick,
      history: {
        listen,
      }
    } = this.props;

    /*
      On Route Change we want to close the navigation. Better to handle this
      straight in the navigation component instead of A pp or other.
     */
    this.listener = listen(() => {
      _onHideClick();
    });

    // _onHideClick();

    this.document = document;
  }

  componentWillUnmount() {
    if (this.listener) {
      this.listener(null, null);
    }
  }

  private _renderOverlay() {
    const {
      _onHideClick,
      appLanguage,
    } = this.props;

    return (
      <Wrapper>
        <ReactCSSTransitionGroup transitionName='overlay' transitionEnterTimeout={700} transitionLeaveTimeout={700}>
          <OverlayWrapper>
            <CloseButton onClick={() => _onHideClick()} />
            <OverlayNavigationList appLanguage={appLanguage} />
            <OverlayBottomContent>
              <AuxNavigationWrapper>
                <AuxNavigation highlightColor={'#FFFFFF'} />
              </AuxNavigationWrapper>
              <SocialMediaNavigation highlightColor={'#FFFFFF'} />
            </OverlayBottomContent>

            <StripeWrapper>
              <FlowStripe animate={true} color={'#000000'} />
            </StripeWrapper>
          </OverlayWrapper>
        </ReactCSSTransitionGroup>
      </Wrapper>
    )
  }

  render() {
    const {
      visible,
    } = this.props;

    if (visible) {
      if (this.document)  {
        this.document.body.classList.add('no-scroll');
        if (getMobileOperatingSystem() === 'iOS') this.noScroll.on();
      }
      return (
        <ReactCSSTransitionGroup
          transitionName='overlay'
          transitionEnterTimeout={OVERLAY_TRANSITION_DURATION}
          transitionLeaveTimeout={OVERLAY_TRANSITION_DURATION}>
          { this._renderOverlay() }
        </ReactCSSTransitionGroup>
      )
    } else {
      if (this.document) {
        this.document.body.classList.remove('no-scroll');
        if (getMobileOperatingSystem() === 'iOS') this.noScroll.off();
      }
      return (
        <ReactCSSTransitionGroup
          transitionName='overlay'
          transitionEnterTimeout={OVERLAY_TRANSITION_DURATION}
          transitionLeaveTimeout={OVERLAY_TRANSITION_DURATION}/>
      );
    }
  }
}

const mapStateToProps = ({ navigationReducer }: any) => {
  const {
    visible,
  } = navigationReducer;

  return {
    visible
  }
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    _onHideClick: () => {
      dispatch(NavigationAction.hide());
    }
  }
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(OverlayNavigationContainer));



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/components/navigation/OverlayNavigation.tsx